export interface PainPoint {
  title: string
  lines: string[]
}

export const painPoints: PainPoint[] = [
  {
    title: '😰 TOO MUCH TIME SPENT PLANNING EVERY PRACTICE...',
    lines: [
      'You know what your team needs. But knowing what to train and having the entire session ready are two different things.',
      'Warm-up. Technical work. Progressions. Tactical situations. Competitive drills. Timing. Player groups. Coaching points.',
      'Every practice requires dozens of decisions. The problem isn’t your coaching knowledge. The problem is having to organize and build everything again and again before you even step onto the court.',
      'Instead of focusing entirely on coaching... You’re still spending hours preparing to coach.',
    ],
  },
  {
    title: '⚠️ HUNDREDS OF DRILLS, BUT WHICH ONE DO YOU NEED TODAY?',
    lines: [
      'Finding volleyball drills isn’t difficult. Finding the right drill for the right problem, level, number of players, and moment of the season is different.',
      'Serving. Serve receive. Setting. Attacking. Blocking. Defense. Transition. Coverage.',
      'You can save dozens of drills and still waste time searching through them before practice. A drill without a clear objective, progression, coaching points, or game connection is just another exercise.',
      'What you need is an organized system that helps you select and adapt the right work quickly.',
    ],
  },
  {
    title: '🏐 YOUR PRACTICE SHOULD CONNECT TO WHAT HAPPENS IN MATCHES',
    lines: [
      'Running drills isn’t enough. Maybe serve receive broke down in your last match. Your block-defense connection was late. Transition offense struggled. Players made too many serving errors. Or your team couldn’t close the set under pressure.',
      'Now you need to transform those problems into the next practice. What should you prioritize? Which progression should you use? How do you recreate the situation? How will you know if it improved?',
      'Without a structured method... It’s easy to run a busy practice without actually solving the problems costing your team points.',
    ],
  },
  {
    title: '😩 AND THE PLANNING NEVER REALLY STOPS',
    lines: [
      'Practice ends. But coaching work continues.',
      'Review the match. Identify problems. Plan the week. Find drills. Adapt exercises. Organize player groups. Prepare the next session. Adjust the plan again.',
      'Knowing volleyball isn’t the problem. Having a complete system of practices, drills, progressions, tactical situations, planning tools, and ready-to-use resources changes everything.',
    ],
  },
]

export const painIntro = [
  'You already know how to coach volleyball. You understand your players, your team, and what needs improvement. But before every practice, the work starts again.',
  'What should we focus on today? Which drills should I use? How should I progress them? How do I keep everyone involved? What needs fixing after the last match?',
  'And above all... How do I build effective practices without spending hours creating everything from scratch?',
]

export const painClose =
  'If you coach regularly, you’ve probably faced at least one of these problems.'
